import { get, post, deleteFun, put } from '@/utils/request.js';
import Qs from 'qs';
// 部门管理

/**
 * 角色列表
 * pageNum
 * pageSize
 */
export function getRoleList(params) {
    return get('/mpp/role/findList', params);
}

/**
 * 角色详情
 * id
 */
export function getRoleById(params) {
    return get('/mpp/role/get', params);
}

/**
 * 新增角色
 *  userName: '',
 * deptId: '',
 * workNumber: '',
 * status: 1
 */
export function addRole(params) {
    return post('/mpp/role/add', params);
}

/**
 * 编辑角色
 *  userName: '',
 * deptId: '',
 * workNumber: '',
 * status: 1
 */
export function editRole(params) {
    return post('/mpp/role/edit', params);
}

/**
 * 删除角色
 * ids: 用户id,支持批量删除
 */
export function deleteRole(params) {
    return deleteFun('/mpp/role/delete', params);
}

/**
 * 根据角色id查询所属用户列表
 * roleId
 *  pageNum
 * pageSize
 */
export function getUserListByRoleId(params) {
    return get('/mpp/role/findUsersByRoleId', params);
}

/**
 * 根据角色id分配用户列表
 * roleId
 * ids 用户id,支持多选
 */
export function addUserListByRoleId(params) {
    return post('/mpp/role/addUsersIntoRole', params);
}

/**
 * 角色授权
 */
export function addMenusIntoRole(params){
    return post('/mpp/role/addMenusIntoRole', params);
}
/**
 * 角色授权
 */
 export function getAuthorize(params){
    return post('/mpp/role/findRoleMenus', params);
}

/**
 * 授权移除
 */
export function deleteUserFromRole(params){
    return deleteFun('/mpp/role/deleteUserFromRole', params);
}